import { createAiHttp, createPublicHttp } from "./aiHttp";

const workshopHttp = createAiHttp();
// Cliente público — sem autenticação (formulários públicos)
const publicHttp = createPublicHttp();

class WorkshopService {
  // ── Admin — Eventos ──────────────────────────────────────────────────────

  ListEvents(contaId) {
    return workshopHttp({ url: "/workshop/" + contaId, method: "GET" });
  }

  CreateEvent(contaId, data) {
    return workshopHttp({ url: "/workshop/" + contaId, data, method: "POST" });
  }

  GetEvent(eventId) {
    return workshopHttp({ url: "/workshop/events/" + eventId, method: "GET" });
  }

  UpdateEvent(eventId, data) {
    return workshopHttp({ url: "/workshop/events/" + eventId, data, method: "PUT" });
  }

  DeleteEvent(eventId) {
    return workshopHttp({ url: "/workshop/events/" + eventId, method: "DELETE" });
  }

  UpdateSchedule(eventId, schedule) {
    return workshopHttp({ url: "/workshop/events/" + eventId + "/schedule", data: { schedule }, method: "PUT" });
  }

  // ── Admin — Inscrições ───────────────────────────────────────────────────

  ListRegistrations(eventId, skip = 0, limit = 20, confirmedOnly = false, search = "") {
    const params = { skip, limit, confirmed_only: confirmedOnly };
    if (search) params.search = search;
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/registrations",
      method: "GET",
      params
    });
  }

  ConfirmRegistration(eventId, regId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/registrations/" + regId + "/confirm",
      method: "PUT"
    });
  }

  UnconfirmRegistration(eventId, regId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/registrations/" + regId + "/confirm",
      method: "DELETE"
    });
  }

  DeleteRegistration(eventId, regId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/registrations/" + regId,
      method: "DELETE"
    });
  }

  ExportRegistrations(eventId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/registrations/export",
      method: "GET",
      responseType: "blob"
    });
  }

  // ── Admin — QR Code e Artwork ────────────────────────────────────────────

  GetQrCode(eventId, baseUrl, artworkType = "registration") {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/qrcode",
      method: "GET",
      params: { base_url: baseUrl, artwork_type: artworkType },
      responseType: "blob"
    });
  }

  GetDefaultPrompt(eventId, artworkType = "registration") {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/artwork/default-prompt",
      method: "GET",
      params: { artwork_type: artworkType }
    });
  }

  GenerateArtwork(eventId, prompt, quality, baseUrl, artworkType = "registration", logoCodes = null, baseFile = null) {
    // Com arte base (multipart): a IA a usa como referência de estilo para uma arte nova.
    if (baseFile) {
      const formData = new FormData();
      formData.append("file", baseFile);
      formData.append("prompt", prompt || "");
      formData.append("quality", quality);
      formData.append("base_url", baseUrl);
      formData.append("artwork_type", artworkType);
      if (logoCodes) formData.append("logo_codes", JSON.stringify(logoCodes));
      return workshopHttp({
        url: "/workshop/events/" + eventId + "/artwork/generate-from-base",
        method: "POST",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" }
      });
    }
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/artwork/generate",
      data: { prompt: prompt || null, quality, base_url: baseUrl, artwork_type: artworkType, logo_codes: logoCodes },
      method: "POST"
    });
  }

  UploadArtwork(eventId, file, artworkType = "registration") {
    const formData = new FormData();
    formData.append("file", file);
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/artwork/upload",
      method: "POST",
      params: { artwork_type: artworkType },
      data: formData,
      headers: { "Content-Type": "multipart/form-data" }
    });
  }

  ListArtworks(eventId, artworkType = null) {
    const params = artworkType ? { artwork_type: artworkType } : {};
    return workshopHttp({ url: "/workshop/events/" + eventId + "/artwork", method: "GET", params });
  }

  DeleteArtwork(eventId, artworkId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/artwork/" + artworkId,
      method: "DELETE"
    });
  }

  // ── Admin — Fotos ────────────────────────────────────────────────────────

  UploadPhoto(eventId, file, caption) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("caption", caption);
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/photos",
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" }
    });
  }

  ListPhotos(eventId) {
    return workshopHttp({ url: "/workshop/events/" + eventId + "/photos", method: "GET" });
  }

  UpdatePhoto(eventId, photoId, data) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/photos/" + photoId,
      data,
      method: "PUT"
    });
  }

  DeletePhoto(eventId, photoId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/photos/" + photoId,
      method: "DELETE"
    });
  }

  DescribePhoto(eventId, photoId) {
    return workshopHttp({
      url: "/workshop/events/" + eventId + "/photos/" + photoId + "/describe",
      method: "POST"
    });
  }

  // ── Público (sem auth) ───────────────────────────────────────────────────

  GetPublicEvent(token) {
    return publicHttp({ url: "/public/workshop/" + token, method: "GET" });
  }

  Register(token, data) {
    return publicHttp({ url: "/public/workshop/" + token + "/register", data, method: "POST" });
  }

  Confirm(token, identifier) {
    return publicHttp({
      url: "/public/workshop/" + token + "/confirm",
      data: { identifier },
      method: "POST"
    });
  }
}

export default new WorkshopService();
